import { Link } from "react-router-dom";
import { BedDouble, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { useLanguage } from "@/i18n";
import { useSEO } from "@/hooks/useSEO";

export default function Stay() {
  const { t } = useLanguage();
  useSEO(t("stay_help_title") + " | Flegrea Experience", t("stay_help_sub"));
  return (
    <div className="py-32 lg:py-44" data-testid="stay-page">
      <div className="max-w-3xl mx-auto px-6 lg:px-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <BedDouble size={32} strokeWidth={1.25} className="text-medblue mx-auto mb-8" />
          <h1 className="font-serif text-4xl md:text-6xl text-ink tracking-tight leading-[1.05]" data-testid="stay-help-title">
            {t("stay_help_title")}
          </h1>
          <p className="mt-6 text-base md:text-lg text-ink/60 leading-relaxed max-w-xl mx-auto" data-testid="stay-help-sub">
            {t("stay_help_sub")}
          </p>
          <Link
            to="/contact"
            data-testid="stay-help-cta"
            className="inline-flex items-center gap-2 mt-10 bg-medblue text-ivory text-xs font-medium uppercase tracking-[0.2em] px-8 py-4 hover:bg-ink transition-colors duration-300"
          >
            {t("stay_help_cta")} <ArrowRight size={14} strokeWidth={1.5} />
          </Link>
        </motion.div>
      </div>
    </div>
  );
}
